// This needs to be a client component although not using any hooks
// because of an issue with MUI Tooltip switching the children type
// and injecting classes after hydration and causing a hydration error
'use client';

import { Box, Tooltip, Typography } from '@mui/material';

export function Desktop({ creditOrCreditScoreLabel }: { creditOrCreditScoreLabel: string }) {
  return (
    <Box sx={{ display: { xs: 'none', md: 'block' } }}>
      <Tooltip
        title={`Recommended ${creditOrCreditScoreLabel}`}
        arrow
        placement="top"
        slotProps={{
          tooltip: {
            sx: {
              padding: '10px 16px',
              fontSize: '14px',
              fontWeight: 400,
            },
          },
        }}
      >
        <Typography
          component="p"
          sx={{ fontSize: '1rem', fontWeight: 700 }}
        >{`Rec. ${creditOrCreditScoreLabel}`}</Typography>
      </Tooltip>
    </Box>
  );
}
